export class StorageBannerModel {
  declare public cssClass: string;
  declare public displayFlag: boolean;
  declare public storageCapacityLimit: number | null | undefined;
  declare public storageUsage: number | null | undefined;
  declare public storageUsagePercentage: number;
}
